import { CssBaseline, Snackbar } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Route,withRouter,Redirect,Switch,DefaultRoute } from 'react-router-dom';
import '../../App.scss';
import { fetchAboutCurrentUser, fetchWakeup, impersonateUser, setContentSize, setIsIE, showImpersonateModal, resetAllReduxState } from '../../reduxActions/AppInfoActions';
import ActionsMain from '../actions/ActionsMain';
import ActionsMainV2 from '../actions/ActionsMainV2';

import FunctionsMain from '../functions/FunctionsMain';
import ProjectsMain from '../projects/ProjectsMain';
import UsersMain from '../users/UsersMain';
import AppHeader from './AppHeader';
import Impersonate from './Impersonate';
import Login from './Login';
import ProceduresManualMain from '../proceduresManual/ProceduresManualMain.js'


// Internet Explorer 6-11
let isIE = /*@cc_on!@*/false || !!document.documentMode;

let byPassLogin = false;//window.location.host === "complianceworks.dev.bechtel.com";

class AppContent extends React.Component {

    updateDimensions() {
        const appBar = document.getElementById('complianceworksappbar');
        const appBarHeight = appBar ? appBar.clientHeight : 64
        this.props.setContentSize({ width: window.innerWidth, height: window.innerHeight - appBarHeight });
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
        this.props.fetchWakeup();
        this.props.setIsIE(isIE);
        this.props.fetchAboutCurrentUser();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render() {

        const { postingImpersonateUpdate,  aboutCurrentUser, shouldShowImpersonateModal,snackbarMessage } = this.props.app;

        return (

            <div>

                    <div>
                        <CssBaseline />
                        <div id="complianceworksappbar">
                        <AppHeader path={this.props.location.pathname} showImpersonateModal={this.props.showImpersonateModal} aboutCurrentUser={aboutCurrentUser} resetAllReduxState={this.props.resetAllReduxState} />
                        </div>
                        {(this.props.app.isLoggedIn || byPassLogin) &&
                            <>
                                               <Switch>
                                                <Route path="/actionsV2" exact component={ActionsMain} />
                                                <Route path="/" exact component={ActionsMainV2} />
                                                <Route path="/actions" exact component={ActionsMainV2}/>
                                                <Route path="/functions" exact component={FunctionsMain}  />
                                                <Route path="/projects" exact component={ProjectsMain} />
                                                <Route path="/users" exact component={UsersMain} />
                                               </Switch>


                            </>
                        }
                        {aboutCurrentUser &&
                                <Impersonate
                                    aboutCurrentUser={this.props.app.aboutCurrentUser}
                                    contentSize={this.props.app.contentSize}
                                    open={shouldShowImpersonateModal}
                                    loading={postingImpersonateUpdate}
                                    onImpersonate={bun => this.props.impersonateUser(bun)}
                                    onCancel={() => this.props.showImpersonateModal(false)}
                                />
                        }
        
                         <Snackbar
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                open={!!snackbarMessage}
                                ContentProps={{
                                    'aria-describedby': 'message-id',
                                }}
                                message={<span id="message-id">{snackbarMessage}</span>}
                            />
                        {!this.props.app.isLoggedIn && !byPassLogin &&
                        <Login/>
                        }
                        {this.props.displayProcedureManual &&
                            <ProceduresManualMain/>
                        }

                    </div>

            </div>

        );
    }

}



const mapStateToProps = (state) => {
    return { 
        
        app: state.app, 
        displayProcedureManual : state.procedureManual.displayProcedureManual
    };
};

export default withRouter(connect(mapStateToProps, {  setContentSize, setIsIE,fetchAboutCurrentUser,fetchWakeup,impersonateUser,showImpersonateModal,resetAllReduxState })(AppContent));
